import styled, { css } from 'styled-components';
import Icon from '@/components/atoms/UI/Icon/Icon';
import { basicColor } from '@/styles/template';
import React from 'react';
import FlexContainer from '@/components/molecules/FlexContainer';

const AdvantagesIcon = styled(Icon)<{ special?: boolean }>`
	border-radius: 100%;
	background:  ${basicColor.secondaryDark};
  	padding: 0.5rem;
  
  	& .colorFill {
	  fill: ${basicColor.white};
    }

	${({ special, theme }) => special && css`
		background: ${theme.color.Overlay};
	`}
`;

const ListItem = styled(FlexContainer)`
	align-items: center;
`

type Props = {
	special?: boolean
	name: string
}

const Advantage: React.FC<Props> = ({special, name}) => {
	return (
		<ListItem gap={'2'}>
			<AdvantagesIcon name={special ? 'Minus' : 'Plus'} size={2.2} special={special}/>
			{name}
		</ListItem>
	)
}

export default Advantage